import { useState } from 'react';

/**
 * Drag-reorderable image list state shared by the section controls.
 * @param {string[]} images   current image paths/URLs
 * @param {(next: string[]) => void} onChange  commit a new array
 */
export const useImageList = (images, onChange) => {
  const [draggedIndex, setDraggedIndex] = useState(null);

  const updateImage = (index, value) => {
    const next = [...images];
    next[index] = value;
    onChange(next);
  };

  const appendImage = (value) => onChange([...images, value]);
  const addImage = () => appendImage('');
  const removeImage = (index) => onChange(images.filter((_, i) => i !== index));

  const onDragStart = (e, index) => {
    setDraggedIndex(index);
    e.dataTransfer.effectAllowed = 'move';
    e.currentTarget.style.opacity = '0.5';
  };

  const onDragEnd = (e) => {
    e.currentTarget.style.opacity = '1';
    setDraggedIndex(null);
  };

  const onDragOver = (e) => {
    e.preventDefault();
    if (e.dataTransfer) e.dataTransfer.dropEffect = 'move';
  };

  const onDrop = (e, dropIndex) => {
    e.preventDefault();
    if (draggedIndex === null || draggedIndex === dropIndex) return;
    const next = [...images];
    const [moved] = next.splice(draggedIndex, 1);
    next.splice(dropIndex, 0, moved);
    onChange(next);
    setDraggedIndex(null);
  };

  return {
    draggedIndex,
    updateImage,
    addImage,
    appendImage,
    removeImage,
    dragHandlers: { onDragStart, onDragEnd, onDragOver, onDrop },
  };
};
